import React from 'react';
import { Box, Grid } from '@mui/material';
import { LineChart, Line, XAxis, YAxis, Tooltip, BarChart, Bar, CartesianGrid, Legend } from 'recharts';
import KPIGrid from '../components/KPIGrid';
import ChartCard from '../components/ChartCard';

const MatchingTab = ({ data }) => {
    if (!data) return <div>Loading...</div>;

    const { kpis, matchRateSeries, replyRateSeries, funnel } = data;

    return (
        <Box height="100%">
            <KPIGrid kpis={kpis} />

            <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                    <ChartCard title="Match Rate Trend">
                        <LineChart data={matchRateSeries}>
                             <CartesianGrid strokeDasharray="3 3" opacity={0.3} />
                             <XAxis dataKey="date" />
                             <YAxis unit="%" />
                             <Tooltip formatter={(val) => `${val}%`} />
                             <Legend />
                             <Line type="monotone" dataKey="value" stroke="#8884d8" name="Match Rate" />
                        </LineChart>
                    </ChartCard>
                </Grid>
                <Grid item xs={12} md={6}>
                    <ChartCard title="Reply Rate Trend">
                        <LineChart data={replyRateSeries}>
                             <CartesianGrid strokeDasharray="3 3" opacity={0.3} />
                             <XAxis dataKey="date" />
                             <YAxis unit="%" />
                             <Tooltip formatter={(val) => `${val}%`} />
                             <Legend />
                             <Line type="monotone" dataKey="value" stroke="#82ca9d" name="Reply Rate" />
                        </LineChart>
                    </ChartCard>
                </Grid>
                <Grid item xs={12}>
                    {/* Funnel Substitute */}
                    <ChartCard title="Matching Funnel Steps">
                        <BarChart data={funnel} layout="vertical">
                             <CartesianGrid strokeDasharray="3 3" opacity={0.3} />
                             <XAxis type="number" />
                             <YAxis dataKey="step" type="category" width={100} tick={{ fontSize: 12 }} />
                             <Tooltip />
                             <Legend />
                             <Bar dataKey="count" fill="#ffc658" name="Count" label={{ position: 'right' }} />
                        </BarChart>
                    </ChartCard>
                </Grid>
            </Grid>
        </Box>
    );
};

export default MatchingTab;
